import Vue from 'vue'

function initialNotifications() {
  return [
    {
      id: 'maintenance-20260722',
      title: '정기 점검 안내',
      message: '7월 22일 02:00부터 03:00까지 서비스 점검이 예정되어 있습니다.',
      isRead: false,
      createdAt: '2026-07-21T09:00:00+09:00',
    },
    {
      id: 'update-20260720',
      title: 'Re:Column 업데이트 안내',
      message: '업무 관리와 CS 문의 기능이 업데이트되었습니다.',
      isRead: false,
      createdAt: '2026-07-20T15:00:00+09:00',
    },
    {
      id: 'privacy-20260718',
      title: '개인정보 처리방침 개정 안내',
      message: '개인정보 처리방침 개정 내용을 확인해 주세요.',
      isRead: true,
      createdAt: '2026-07-18T10:00:00+09:00',
    },
  ]
}

const state = Vue.observable({ notifications: initialNotifications() })

export const systemNotificationRepository = {
  state,
  list() {
    return state.notifications
  },
  markRead(id) {
    const item = state.notifications.find(notification => String(notification.id) === String(id))
    if (item) Vue.set(item, 'isRead', true)
    return item || null
  },
  reset() {
    state.notifications.splice(0, state.notifications.length, ...initialNotifications())
  },
}
